import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { Model } from 'projects/core/src/include/model';
import { ToDo } from '../../../todo';
import { ActivatedRoute } from '@angular/router';
import { TodoService } from '../../../services/todo.service';
import { Globals } from 'projects/core/src/globals';
import { AddressComponent } from 'projects/c1-backend/src/app/views/address/address.component';
import { AddressDetailsComponent } from 'projects/c1-backend/src/app/views/address/address-details/address-details.component';
import { Helper } from 'projects/core/src/helper';
import { AddressesService } from 'projects/c1-backend/src/app/services/addresses.service';

@Component({
  selector: 'app-detail',
  templateUrl: './detail.component.html',
  styleUrl: './detail.component.css'
})
export class DetailComponent extends Model<ToDo> implements OnInit,AfterViewInit{

  @Input()
  id_address=0;


  constructor(
      private route1: ActivatedRoute,
      private todoService: TodoService,
      private addressesService:AddressesService
    ) { 
      super(route1,todoService);
    }
  
    ngOnInit(): void {
  
      this.title = 'Dettaglio Promemoria';
      super.ngOnInit.apply(this); 
      
      this.afterGetItem=()=>{
          if(this.id==0){
            // console.log("New record")
             this.record.date_from=new Date().toMysqlDate();
             this.record.date_to=new Date("2999-12-31 23:59:59").toMysqlDate()
             this.record.state=1;
             
             if( this.id_address>0){
               this.addressesService.getItem(this.id_address).subscribe((item)=>{
                this.record.addressItem=item;
                this.record.id_address=this.id_address;
                this.record.addressname=this.record.addressItem.name;
               });
             }
          }else{
           
    
          }
          
          
      }

      this.getItem();

      this.record.id_address=this.id_address;
     
    }

    ngAfterViewInit(): void {
        
    
        
      }



     selectAddress(){
      Globals.modal.showModal(AddressComponent,[{"name":"mode","value":"modal"}],(instance)=>{
        if(instance['recordSelected']){
          this.record.addressItem=instance['recordSelected'];
          this.record.addressname=this.record.addressItem.name;
          this.record.id_address=this.record.addressItem.id;
        }
      })
    }
    
    addAddress(){
      Globals.modal.showModal(AddressDetailsComponent,[{"name":"mode","value":"modal"}],(instance)=>{
        if(instance!=null){
          this.record.addressItem=instance['record'];
          this.record.id_address=this.record.addressItem.id;
        }
      })
    }
    
    OnViewAddress(r){
      Globals.modal.showModal(AddressDetailsComponent,[
        {"name":"mode","value":"modal"},
        {"name":"id","value":r.id}
      ],(instance)=>{
        if(instance!=null)
          this.OnSelectAddress(instance['record']);
      });
    }
    
    OnSelectAddress(r){
      if(r){
        this.record.addressItem=r;
        this.record.id_address=r.id;
      }
    }
    


}
